import { useCallback, useMemo } from 'react';
import { useAuthStore } from '../stores/auth.store';
import { usersService } from '../services/users.service';
import { resolveTrackingPresets, type TrackingPreset } from '../utils/tracking-presets';

export function useTrackingPresets() {
  const stored = useAuthStore((s) => s.user?.settings?.presets);
  const setUserSettings = useAuthStore((s) => s.setUserSettings);

  const presets = useMemo(() => resolveTrackingPresets(stored), [stored]);

  // presets area only — avoid cross-tab clobber
  const savePresets = useCallback(async (next: TrackingPreset[]) => {
    const current = useAuthStore.getState().user;
    if (!current?.id) return;
    const updated = await usersService.update(current.id, { settings: { presets: next } });
    setUserSettings(updated.settings || {});
  }, [setUserSettings]);

  return { presets, savePresets };
}
